module.exports = __webpack_public_path__ + "static/hero-0931c409587870316583bf7050ec9c5a.jpg";